import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import img47 from "../../assets/img47.jpg";
import img48 from "../../assets/img48.webp";
import img49 from "../../assets/img49.webp";
import img50 from "../../assets/img50.jpg";
import img51 from "../../assets/img51.png";
import img53 from "../../assets/img53.webp";
import img54 from "../../assets/img54.webp";
import img52 from "../../assets/img52.jpeg";
import img55 from "../../assets/img55.jpeg";
import img56 from "../../assets/img56.jpg";
import img57 from "../../assets/img57.jpeg";
import img58 from "../../assets/img58.jpeg";
import img59 from "../../assets/img59.jpeg";
import img60 from "../../assets/img60.jpeg";
import img61 from "../../assets/img61.jpeg";
import img62 from "../../assets/img62.jpeg";
import img63 from "../../assets/img63.webp";

const CaseStudies = () => {
  const siteContainer = "mx-auto w-full max-w-[1380px] px-4 sm:px-6 lg:px-10";

  return (
    <>
      <SEO
        title="Insurance Case Studies & Success Stories  – einsured.ca"
        description="Explore detailed insurance case studies at einsured.ca, showcasing how our expert guidance and tailored solutions have helped clients across Canada succeed."
        keywords="Insurance Case Studies, life insurance success stories, multiple sclerosis insurance approval, diabetes life insurance canada"
      />
      {/* HERO SECTION */}
      <section
        className="relative min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] flex items-center justify-center md:justify-start bg-cover bg-top"
        style={{
          backgroundImage: `url(${img47})`,
          backgroundPosition: "center top",
        }}
      >
        <div className="absolute inset-0 bg-black/20" />

        <div
          className={`relative z-10 w-full ${siteContainer} pt-20 sm:pt-24 md:pt-28`}
        >
          <div className="max-w-xl bg-white/95 rounded-[2.5rem] shadow-lg px-6 sm:px-10 py-8 sm:py-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#49628b] mb-3 leading-tight">
              Case studies
            </h1>

            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
              Welcome to einsured.ca&apos;s Case Studies Section
            </h2>

            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              .At einsured.ca, we pride ourselves on our extensive experience
              and comprehensive expertise in navigating the complex world of
              insurance. We believe in transparency and the power of real-world
              examples to illustrate the value we bring to our clients. Below,
              you’ll find a selection of case studies that showcase our ability
              to provide tailored, effective insurance solutions across various
              sectors and client types.
            </p>
          </div>
        </div>
      </section>

      {/* CASE STUDY 1 */}
      <section className="py-20 bg-white text-gray-900">
        <div className={siteContainer}>
          <div className="text-center mb-12">
            <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-6 py-2 rounded-full">
              Case Study 1
            </span>
          </div>

          {/* Two Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-stretch">
            {/* LEFT CARD */}
            <div className="relative bg-[#4B638A] rounded-[28px] p-6 sm:p-8 text-white flex flex-col">
              <div className="absolute left-8 top-0 -translate-y-1/2">
                <span className="inline-flex items-center bg-[#00c6ff] text-white font-bold px-7 py-2 rounded-full border-2 border-white/80 shadow">
                  Client
                </span>
              </div>

              <div className="flex flex-col flex-1 pt-6">
                {/* Inner White Box */}
                <div className="bg-white text-[#49628b] rounded-[22px] p-6 sm:p-8 shadow-md flex-1">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-4 text-sm sm:text-base">
                    <p>
                      <span className="text-gray-500 font-medium">Age</span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg">
                        41
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Condition
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        Weight loss surgery
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Approval
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">7 Days</span>
                    </p>
                  </div>

                  <div className="mt-6 grid grid-cols-1 sm:grid-cols-[minmax(0,1fr)_auto] gap-4 items-end">
                    <p>
                      <span className="text-gray-500 font-medium">
                        Need Analysis
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg leading-snug">
                        Non-medical Life Insurance
                        <br className="hidden sm:block" />
                        applied
                      </span>
                    </p>

                    <span className="inline-block bg-[#00c6ff] text-white font-semibold text-xs sm:text-sm px-5 py-2 rounded-full text-center shadow-sm">
                      without any weight question
                    </span>
                  </div>
                </div>

                {/* Image */}
                <div className="mt-6 bg-white rounded-[22px] p-2 shadow-sm">
                  <div className="rounded-[18px] overflow-hidden">
                    <img
                      src={img48}
                      alt="Client 1"
                      className="w-full h-[240px] sm:h-[270px] md:h-[300px] object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT CARD */}
            <div className="relative bg-[#4B638A] rounded-[28px] p-6 sm:p-8 text-white flex flex-col">
              <div className="absolute left-8 top-0 -translate-y-1/2">
                <span className="inline-flex items-center bg-[#00c6ff] text-white font-bold px-7 py-2 rounded-full border-2 border-white/80 shadow">
                  Client
                </span>
              </div>

              <div className="flex flex-col flex-1 pt-6">
                {/* Inner White Box */}
                <div className="bg-white text-[#49628b] rounded-[22px] p-6 sm:p-8 shadow-md flex-1">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-5 text-sm sm:text-base">
                    <p>
                      <span className="text-gray-500 font-medium">Age</span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg">
                        41
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">Gender</span>
                      <br />
                      <span className="font-bold text-[#49628b]">Female</span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Condition
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        Weight loss surgery
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Approval
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">7 Days</span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Application Time
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        35 minutes
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Discussion &amp; meeting
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        50 minutes
                      </span>
                    </p>
                  </div>
                </div>

                {/* Image */}
                <div className="mt-6 bg-white rounded-[22px] p-2 shadow-sm">
                  <div className="rounded-[18px] overflow-hidden">
                    <img
                      loading="lazy"
                      src={img49}
                      alt="Client 2"
                      className="w-full h-[240px] sm:h-[270px] md:h-[300px] object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 2 */}
      <section className="py-20 bg-[#f1f8ff] text-gray-900">
        <div className={siteContainer}>
          <div className="mb-8">
            <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-6 py-2 rounded-full">
              Case Study 2
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
            {/* Left side text */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              <p className="text-sm sm:text-base text-[#49628b] leading-relaxed mb-6">
                A young couple,{" "}
                <span className="font-bold">
                  both healthy 30 and 32 year old non-smokers
                </span>
                , are eager to start their new family in their new home.
              </p>

              <div className="bg-white rounded-[2rem] shadow-md px-6 sm:px-8 py-6 sm:py-8 text-sm sm:text-base text-[#49628b] leading-relaxed">
                <p className="mb-6 leading-relaxed">
                  <span className="font-bold block mb-2">Concern:</span>
                  <span>
                    To ensure they have financial protection should the{" "}
                    <span className="font-bold text-[#49628b]">
                      unexpected happen.
                    </span>
                  </span>
                </p>

                <div className="leading-relaxed">
                  <span className="font-bold block mb-2">Needs Analysis:</span>

                  <div className="space-y-2">
                    <p>
                      Short-term life insurance needs covering mortgage and bank
                      loans:{" "}
                      <span className="font-bold text-[#49628b]">
                        $350,000 each
                      </span>
                    </p>

                    <p>
                      Long-term life insurance needs covering funeral costs and
                      final expenses:{" "}
                      <span className="font-bold text-[#49628b]">
                        $50,000 each
                      </span>
                    </p>

                    <p>
                      Income protection need if diagnosed with a critical
                      illness:{" "}
                      <span className="font-bold text-[#49628b]">
                        $50,000 each
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right side image */}
            <div className="rounded-[2rem] overflow-hidden bg-white shadow-md">
              <img
                loading="lazy"
                src={img50}
                alt="Young couple sitting together on a sofa"
                className="w-full h-[260px] sm:h-[300px] md:h-[340px] object-cover"
              />
            </div>
          </div>

          {/* table image */}
          <div className="mt-16">
            <div className="max-w-4xl mx-auto rounded-[2rem] overflow-hidden shadow-md bg-[#415a9c]">
              <img
                loading="lazy"
                src={img51}
                alt="Coverage table for Case Study 2"
                className="w-full h-auto object-contain"
              />
            </div>

            <p className="mt-8 text-sm sm:text-base leading-relaxed text-[#49628b] max-w-4xl mx-auto">
              Prices are subject to increase or decrease according to the
              associated insurance provider. As retirement looms, the need for
              insurance protection may dwindle for clients, who may instead
              require cash. To meet this need, clients can opt to surrender
              their policy and receive the available cash surrender value (CSV)
              at the age 65.
            </p>
          </div>
        </div>
      </section>

      {/* CASE STUDY 3 */}
      <section className="py-20 bg-[#415a9c] text-gray-900">
        <div className={siteContainer}>
          <div className="text-center mb-10">
            <span className="inline-block bg-white text-[#49628b] font-semibold text-lg sm:text-xl px-8 py-3 rounded-full shadow-md">
              Case Study 3
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-stretch">
            {/* LEFT CARD */}
            <div className="bg-[#f4fbff] rounded-[2.5rem] px-6 sm:px-8 pt-8 pb-10 flex flex-col">
              <div className="inline-block bg-[#00c6ff] text-white font-bold px-8 py-2 rounded-full mb-6">
                Client
              </div>

              <div className="flex flex-col flex-1">
                {/* White box */}
                <div className="bg-white rounded-[1.5rem] px-6 sm:px-8 py-6 sm:py-7 shadow-md flex-1">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3 text-sm sm:text-base text-[#49628b]">
                    <p>
                      <span className="font-semibold text-gray-600">Age</span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg">
                        35
                      </span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Condition
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">Diabetic</span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Approval
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">7 Days</span>
                    </p>
                  </div>

                  <div className="mt-6 text-sm sm:text-base text-[#49628b]">
                    <p className="font-semibold text-gray-600 mb-1">
                      Needs Analysis
                    </p>
                    <p className="font-bold text-[#49628b]">
                      No-medical Life Insurance applied
                    </p>
                  </div>
                </div>

                <div className="mt-6 rounded-[1.75rem] border-[6px] border-[#1e8bcf] overflow-hidden">
                  <img
                    loading="lazy"
                    src={img53}
                    alt="Diabetic male client"
                    className="w-full h-[220px] sm:h-[240px] md:h-[260px] object-cover"
                  />
                </div>
              </div>
            </div>

            {/* RIGHT CARD */}
            <div className="bg-[#f4fbff] rounded-[2.5rem] px-6 sm:px-8 pt-8 pb-10 flex flex-col">
              <div className="inline-block bg-[#00c6ff] text-white font-bold px-8 py-2 rounded-full mb-6">
                Client
              </div>

              <div className="flex flex-col flex-1">
                {/* White box */}
                <div className="bg-white rounded-[1.5rem] px-6 sm:px-8 py-6 sm:py-7 shadow-md flex-1">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3 text-sm sm:text-base text-[#49628b]">
                    <p>
                      <span className="font-semibold text-gray-600">Age</span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg">
                        35
                      </span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Gender
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">Female</span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Approval
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">10 Days</span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Condition
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">Diabetic</span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Application Time
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        40 minutes
                      </span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Discussion &amp; meeting
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        45 minutes
                      </span>
                    </p>
                  </div>
                </div>

                <div className="mt-6 rounded-[1.75rem] border-[6px] border-[#1e8bcf] overflow-hidden">
                  <img
                    loading="lazy"
                    src={img54}
                    alt="Diabetic female client"
                    className="w-full h-[220px] sm:h-[240px] md:h-[260px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 4 */}
      <section className="py-20 bg-[#f1f8ff] text-gray-900">
        <div className={`${siteContainer} relative`}>
          <div className="mb-8">
            <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-6 py-2 rounded-full">
              Case Study 4
            </span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10">
            {/* Left text */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
                Diagnosed with Multiple sclerosis 7 years ago
              </p>

              <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[2.5rem] px-8 py-5 mb-8 max-w-xl text-sm sm:text-base leading-relaxed">
                No-medical Life insurance approved from
                <br />
                an A rated life insurance company
              </div>

              {/* Details */}
              <div className="space-y-3 text-sm sm:text-base text-[#49628b]">
                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">Age:</span>{" "}
                  <span className="font-bold">35</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Gender:
                  </span>{" "}
                  <span className="font-bold">Male</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-bold">Non-smoker</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Condition:
                  </span>{" "}
                  <span className="font-bold">Chronic Multiple sclerosis</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Application Time:
                  </span>{" "}
                  <span className="font-bold">40 minutes</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Review and Discussion:
                  </span>{" "}
                  <span className="font-bold">50 minutes</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Approval after submission:
                  </span>{" "}
                  <span className="font-bold">6 Days</span>
                </p>
              </div>
            </div>

            {/* Right image */}
            <div className="rounded-[2.5rem] overflow-hidden bg-white shadow-md">
              <img
                loading="lazy"
                src={img52}
                alt="Client with multiple sclerosis"
                className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 5 */}
      <section className="py-20 text-gray-900">
        <div className={siteContainer}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* LEFT IMAGE */}
            <div className="rounded-[2.5rem] overflow-hidden bg-white shadow-md">
              <img
                loading="lazy"
                src={img55}
                alt="Client with diabetes requiring insulin"
                className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
              />
            </div>

            {/* RIGHT Text */}
            <div>
              <div className="mb-6">
                <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-7 py-2 rounded-full">
                  Case Study 5
                </span>
              </div>

              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
                Unable to buy insurance because of diabetes requiring insulin.
              </p>

              <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[2.5rem] px-8 py-5 mb-8 max-w-xl text-sm sm:text-base leading-relaxed">
                No-medical Life Insurance APPROVED in 5 Days!
                <br />
                Congratulations to our client!
              </div>

              {/* Details */}
              <div className="space-y-3 text-sm sm:text-base text-[#49628b]">
                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">Age:</span>{" "}
                  <span className="font-bold">44</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Gender:
                  </span>{" "}
                  <span className="font-bold">Male</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-bold">Non-smoker</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Condition:
                  </span>{" "}
                  <span className="font-bold">
                    Diagnosed with diabetes more than 11 years ago.
                  </span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Application Time:
                  </span>{" "}
                  <span className="font-bold">45 minutes</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Review and Discussion:
                  </span>{" "}
                  <span className="font-bold">45 minutes</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Approval after submission:
                  </span>{" "}
                  <span className="font-bold">5 Days</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 6 SECTION */}
      <section className="relative py-20 bg-[#f1f8ff] text-gray-900 overflow-hidden">
        <div
          className={`relative ${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT TEXT */}
          <div className="z-10">
            <div className="mb-6">
              <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-7 py-2 rounded-full">
                Case Study 6
              </span>
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>

            <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
              John &amp; Cynthia took mortgage insurance from Bank
            </p>
            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              <ul className="list-disc ml-5 space-y-1">
                <li>High Premiums</li>
                <li>Couldn’t update beneficiaries without Bank approval</li>
                <li>
                  Faced 3 month delays just to change policy details after
                  having a child
                </li>
              </ul>
            </div>

            <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
              They consulted a private mortgage insurance advisor and switched
              providers.
            </p>

            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              <ul className="list-disc ml-5 space-y-1">
                <li>They became the policy owners</li>
                <li>Could update beneficiaries instantly</li>
                <li>Lower, fixed premiums</li>
                <li>Coverage stays intact even if they switched lenders</li>
              </ul>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="relative rounded-[2.5rem] overflow-hidden bg-white shadow-md">
            <img
              loading="lazy"
              src={img56}
              alt="John & Cynthia with family"
              className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
            />
          </div>
        </div>
      </section>

      {/* CASE STUDY 7 */}
      <section className="py-20 text-gray-900">
        <div
          className={`${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT IMAGE */}
          <div className="rounded-[2.5rem] overflow-hidden bg-white shadow-md">
            <img
              loading="lazy"
              src={img57}
              alt="David the truck driver"
              className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div>
            <div className="mb-6">
              <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-7 py-2 rounded-full">
                Case Study 7
              </span>
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>

            <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
              David, a 35 year-old Truck Driver, self-employed
            </p>

            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              David slipped while unloading cargo and suffered a severe spinal
              injury. Unable to work, his income stopped overnight.
            </div>

            <div className="space-y-5 text-sm sm:text-base leading-relaxed">
              <p>
                <span className="font-bold text-[#1f2933]">
                  No income, No savings:
                </span>{" "}
                <span className="text-black">
                  Without disability insurance, David’s savings ran out. Bills
                  piled up, and his wife had to take extra work. With disability
                  coverage, he could have received monthly benefits.
                </span>
              </p>

              <p>
                <span className="font-bold text-[#1f2933]">
                  Protect your future before it's TOO LATE!{" "}
                </span>
                David’s story is a reminder - life is unpredictable. Disability
                insurance ensures financial stability when you can’t work.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 8 */}
      <section className="py-20 bg-[#f1f8ff] text-gray-900">
        <div
          className={`${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT CONTENT */}
          <div>
            <div className="mb-6">
              <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-7 py-2 rounded-full">
                Case Study 8
              </span>
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>

            <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
              Purchased Deferred Elite Term-10 with $100,000 coverage, deceased.
            </p>

            {/* Blue info box */}
            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              Death benefit fully paid after assessment
            </div>

            {/* List */}
            <div className="space-y-3 text-sm sm:text-base text-[#49628b]">
              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-semibold text-gray-700">Age:</span>{" "}
                <span className="font-bold">35</span>
              </p>

              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-semibold text-gray-700">
                  Gender:
                </span>{" "}
                <span className="font-bold">Male</span>
              </p>

              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-bold">Non-smoker</span>
              </p>

              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-semibold text-gray-700">
                  Documents required:
                </span>{" "}
                <span className="font-bold">
                  Claimant’s assessment, APS, coroner’s report
                </span>
              </p>

              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-semibold text-gray-700">
                  Claim decision:
                </span>{" "}
                <span className="font-bold">Fully paid</span>
              </p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="rounded-[2.5rem] overflow-hidden bg-white shadow-md">
            <img
              loading="lazy"
              src={img58}
              alt="Family reviewing documents after insurance claim"
              className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
            />
          </div>
        </div>
      </section>

      {/* CASE STUDY 9 SECTION */}
      <section className="py-16">
        <div
          className={`${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT: IMAGE */}
          <div className="order-1">
            <div className="rounded-[2rem] overflow-hidden shadow-md">
              <img
                loading="lazy"
                src={img59}
                alt="Raj and Simran with their child"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="order-2">
            <div className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-8 py-3 rounded-full mb-4">
              Case Study 9
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>
            <p className="text-sm sm:text-base text-gray-800 mb-6">
              Raj (32) and Simran (29), parents of a 2-year-old. Household
              income:
              <span className="font-semibold text-[#49628b]"> $85,000.</span>
            </p>

            {/* Blue Info Box */}
            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              <p className="text-sm sm:text-base leading-relaxed">
                They wanted life insurance but worried about affordability with
                daycare and mortgage expenses.
              </p>
            </div>

            {/* Solution */}
            <div className="flex items-start gap-3 mb-4">
              <span className="text-[#49628b] text-lg leading-relaxed">▶</span>
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                <span className="font-semibold text-[#49628b]">Solution: </span>
                We compared policies across multiple providers and secured a
                20-year Term Life policy for Raj at just{" "}
                <span className="font-semibold text-[#49628b]">
                  $28/month
                </span>{" "}
                and Simran at{" "}
                <span className="font-semibold text-[#49628b]">$21/month.</span>
              </p>
            </div>

            {/* Outcome */}
            <div className="flex items-start gap-3">
              <span className="text-[#49628b] text-lg leading-relaxed">▶</span>
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                <span className="font-semibold text-[#49628b]">Outcome: </span>
                For under{" "}
                <span className="font-semibold text-[#49628b]">$50/month</span>,
                the family has{" "}
                <span className="font-semibold text-[#49628b]">$500,000</span>{" "}
                coverage each, ensuring their child’s future is protected even
                if something unexpected happens.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 10 SECTION */}
      <section className="bg-[#f5fbff] py-16">
        <div
          className={`${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT CONTENT */}
          <div className="order-2 lg:order-1">
            <div className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-8 py-3 rounded-full mb-4">
              Case Study 10
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>

            <p className="text-sm sm:text-base text-gray-800 mb-6 font-semibold">
              Self-Employed Professional:{" "}
              <span className="text-[#49628b] font-bold">Amandeep (40)</span>,
              owns a trucking business, income around{" "}
              <span className="text-[#49628b] font-bold">$120,000 / year.</span>
            </p>

            {/* Blue Info Box */}
            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              <p className="text-sm sm:text-base leading-relaxed">
                No employer benefits, wanted coverage that also builds cash for
                retirement.
              </p>
            </div>

            {/* Solution */}
            <div className="flex items-start gap-3 mb-4">
              <span className="text-[#49628b] text-lg leading-relaxed">▶</span>
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                <span className="font-semibold text-[#49628b]">Solution:</span>{" "}
                We recommended a{" "}
                <span className="font-semibold text-[#49628b]">
                  Whole Life Insurance
                </span>{" "}
                plan that provides lifelong protection plus cash-value growth.
              </p>
            </div>

            {/* Outcome */}
            <div className="flex items-start gap-3">
              <span className="text-[#49628b] text-lg leading-relaxed">▶</span>
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                <span className="font-semibold text-[#49628b]">Outcome:</span>{" "}
                Amandeep now has peace of mind knowing his family is covered,
                while also building a financial reserve he can use later for
                business expansion or retirement planning.
              </p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="order-1 lg:order-2">
            <div className="rounded-[2rem] overflow-hidden shadow-md">
              <img
                loading="lazy"
                src={img60}
                alt="Amandeep, self-employed trucking business owner"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 11 */}
      <section className="py-16 sm:py-20">
        <div className={siteContainer}>
          <div className="flex flex-col lg:flex-row items-stretch gap-10">
            {/* LEFT IMAGE */}
            <div className="flex-1 rounded-[2.5rem] overflow-hidden shadow-md">
              <img
                loading="lazy"
                src={img61}
                alt="Harpreet, nearing retirement, standing with a book"
                className="w-full h-full object-cover"
              />
            </div>

            {/* RIGHT CONTENT */}
            <div className="flex-1 flex flex-col justify-center">
              <div className="mb-4">
                <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-8 py-3 rounded-full shadow-sm">
                  Case Study 11
                </span>
              </div>

              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              <p className="text-sm sm:text-base md:text-lg font-semibold text-[#143451] mb-6">
                Harpreet (55), nearing retirement, with a paid-off home and 2
                adult children.
              </p>

              {/* Blue info box */}
              <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
                <p className="text-sm sm:text-base leading-relaxed">
                  Didn’t need income replacement but wanted to cover final
                  expenses and leave a tax-free legacy.
                </p>
              </div>

              <div className="mt-6 space-y-4 text-sm sm:text-base text-[#1f2a3d]">
                {/* Solution */}
                <div className="flex items-start gap-2">
                  <span className="text-[#49628b] text-lg leading-relaxed">
                    ▶
                  </span>
                  <p>
                    <span className="font-semibold">Solution:</span> A Permanent
                    Life Insurance policy for $250,000. Premiums: $190/month.
                  </p>
                </div>

                {/* Outcome */}
                <div className="flex items-start gap-2">
                  <span className="text-[#49628b] text-lg leading-relaxed">
                    ▶
                  </span>
                  <p>
                    <span className="font-semibold">Outcome:</span> Guaranteed
                    tax-free payout to her children, plus peace of mind knowing
                    her estate costs will be covered.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 12 SECTION */}
      <section className="bg-[#f4fbff] py-16 sm:py-20">
        <div className={siteContainer}>
          <div className="flex flex-col lg:flex-row items-stretch gap-10">
            {/* LEFT CONTENT */}
            <div className="flex-1 flex flex-col justify-center">
              <div className="mb-4">
                <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-8 py-3 rounded-full shadow-sm">
                  Case Study 12
                </span>
              </div>

              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              {/* Client details */}
              <p className="text-sm sm:text-base md:text-lg font-semibold text-[#143451] mb-6">
                Mr. & Mrs. Sharma, both 62, visiting their son in Brampton.
              </p>

              <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
                <p className="text-sm sm:text-base leading-relaxed">
                  Needed Super Visa Insurance for 2 years but were overwhelmed
                  by high costs.
                </p>
              </div>

              <div className="space-y-4 text-sm sm:text-base text-[#143451]">
                {/* Solution */}
                <div className="flex items-start gap-2">
                  <span className="text-[#49628b] text-lg leading-relaxed">
                    ▶
                  </span>
                  <p>
                    <span className="font-semibold">Solution:</span> We compared
                    8+ insurers and found a $100,000 medical coverage refundable
                    policy, with a monthly payment option.
                  </p>
                </div>

                {/* Outcome */}
                <div className="flex items-start gap-2">
                  <span className="text-[#49628b] text-lg leading-relaxed">
                    ▶
                  </span>
                  <p>
                    <span className="font-semibold">Outcome:</span> Savings of
                    nearly $1,200 compared to their bank’s quote, with flexible
                    payments. They entered Canada stress-free, knowing medical
                    emergencies are covered.
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="flex-1 rounded-[2.5rem] overflow-hidden shadow-md">
              <img
                loading="lazy"
                src={img62}
                alt="Mr. and Mrs. Sharma smiling together"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Interested in discussing your specific needs? */}
      <section className="bg-[#f4fbff] py-20 sm:py-24">
        <div className={siteContainer}>
          {/* Blue Gradient Box */}
          <div className="bg-gradient-to-r from-[#1e48a0] to-[#00c6ff] rounded-[2rem] p-8 sm:p-10 text-center text-white shadow-md">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4">
              Interested in discussing your specific needs?
            </h2>

            <p className="text-base sm:text-lg max-w-2xl mx-auto mb-8 leading-relaxed text-white/90">
              Book a meeting today for a comprehensive insurance review and
              discover how we can tailor our solutions to your unique
              challenges.
            </p>

            {/* Contact Button */}
            {/* Contact Button */}
            <Link
              to="/book-a-meeting"
              className="bg-[#00b4ff] hover:bg-[#009de6] text-white font-semibold px-8 py-3 rounded-full shadow-md transition-all w-full sm:w-auto text-base sm:text-lg"
            >
              Contact Us
            </Link>

            <div className="mt-10 rounded-[2rem] overflow-hidden border-[6px] border-white shadow-lg bg-white">
              <img
                loading="lazy"
                src={img63}
                alt="Happy family insurance consultation"
                className="block w-full h-full object-cover -mt-1"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CaseStudies;
